import React, {Component} from 'react'
import {Accordion, Icon, Grid, Popup} from 'semantic-ui-react'
import {formatDate} from '../cads/format-date'
import {_rep, unminifyAccountName} from '../cads/unminify'
import {filterShippedOrders} from './filter-sales-orders'
import {showOrderMargin, orderMarginPercent} from './order-margin'

const colStyle = {textOverflow: 'ellipsis', overflow: 'hidden'}

class OrderAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {active: false}
  }

  toggleAccordion = () => this.setState({active: !this.state.active})

  render() {
    let {shippedData, contact, fromDate, toDate, expandAll, cad, atsRep, showFields} = this.props
    let {active} = this.state

    let marginCad = showOrderMargin(showFields) ? cad : null
    let atsRepData = atsRep == null ? null : atsRep[cad.i]

    let orders = shippedData == null ? [] : shippedData.sort((a, b) => {return a.d > b.d ? 1 : -1})

    orders = filterShippedOrders(orders, contact, fromDate, toDate)

    const totalShipped = orders.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.q)
    }, 0)

    if (expandAll) {
      active = true
    }

    return (
      <React.Fragment>
        <Accordion>
          <Accordion.Title onClick={expandAll ? () => {} : this.toggleAccordion} >
            {
              totalShipped > 0
              ?
              <Icon name='dropdown' style={active ? {rotate: '90deg'} : {}}/>
              :
              null
            }
            SHIPPED ({totalShipped})
          </Accordion.Title>
          <Accordion.Content active={active && totalShipped > 0}>
            <Grid stackable columns={4}>
              {orders.map((x, index) =>
                <React.Fragment>
                  <Grid.Row columns={marginCad == null ? 4 : 5}>
                    <Grid.Column>{x.q}</Grid.Column>
                    <Grid.Column>${x.s}</Grid.Column>
                    {marginCad == null ? null : <Grid.Column>{orderMarginPercent(x.s, marginCad, atsRepData) == null ? '' : orderMarginPercent(x.s, marginCad, atsRepData) + '%'}</Grid.Column>}
                    <Grid.Column>{formatDate(x.d)}</Grid.Column>
                    <Grid.Column style={{wordBreak: 'break-all'}}>{x.p}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{marginTop: '-15px', borderBottom: '1px solid rgb(212,212,212)'}}>
                    <Grid.Column style={colStyle}>{_rep(x)}</Grid.Column>
                    <Grid.Column style={colStyle}>{unminifyAccountName(x.a)}</Grid.Column>
                  </Grid.Row>
                </React.Fragment>
              )}
            </Grid>
          </Accordion.Content>
        </Accordion>
      </React.Fragment>
    )
  }
}

export default OrderAccordion
